// extracted by mini-css-extract-plugin
export default {"recos":"b4-z","productCardOverride":"c4-z","rowHasBadge":"d4-z"};